import React from 'react'
import {DefaultProps, RefTable, PaginatedLoad, Refresh} from "./RefTable";


export const MassPostSaleLog = (props)=><RefTable {...props}/>;

MassPostSaleLog.defaultProps = {
    ...DefaultProps,
    title: "Mass Post Sale Log",
    tableSchema: "em_mass_post_sale_job_view",
    tableName: "em_mass_post_sale_job_view",
    filterSchema:"em_mass_post_sale_job_filter",
    edit: false,
    add: false,
    theadHeight: 64,
    tfootHeight: 50,
    customActionElements:[<Refresh key={"refresh-action"}/>],
    fetch: PaginatedLoad
}
